import { BrowserRouter as Router } from "react-router-dom";
import { DetailsProvider } from "./DetailsContext";
import { Suspense } from "react";
import App from "./App";

const AppProvider = () => {
  return (
    <Suspense fallback={<></>}>
      <DetailsProvider>
        <Router>
          <App />
        </Router>
      </DetailsProvider>
    </Suspense>
  );
};

export default AppProvider;
